import axios from 'axios';

const URL = "https://api.ipdata.co/?"
const API_KEY = "4526efd384bf49f8a6f308a07f6430d70228b930644c7dd27daaa6dc"
export const fetchIp = async() => {
    const res = await fetch(`https://api.ipdata.co/?api-key=${API_KEY}`);
    const data = res.json()
 return data;
}